"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusFlags = exports.AmplitudeSubscriberStatusFlags = void 0;
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// each flag below is a single bit that'll be flipped to represent its status.
// when adding a new flag, we need to ensure that it's using an unused bit in
// the status "register". to make that a bit easier to follow, all the flags
// are setup as a bitshift left of one, the next number of bits. just iterate
// the number of bits shifted left and feel comforted that your bit is unique
var AmplitudeSubscriberStatusFlags = exports.AmplitudeSubscriberStatusFlags = {
  Instantiated: 1 << 0,
  //              0b00000000000000001
  PassedWindowCheck: 1 << 1,
  //         0b00000000000000010
  ConsentBannerEventBound: 1 << 2,
  //   0b00000000000000100
  InitializeStarted: 1 << 3,
  //         0b00000000000001000
  InitializeConfigOk: 1 << 4,
  //        0b00000000000010000
  AnonymousMode: 1 << 5,
  //             0b00000000000100000
  ClientCreated: 1 << 6,
  //             0b00000000001000000
  SentInitialUserProps: 1 << 7,
  //      0b00000000010000000
  SessionReplayInitialized: 1 << 8,
  //  0b00000000100000000
  ClientInitialized: 1 << 9,
  //         0b00000001000000000
  InCookieConsentRetry: 1 << 10,
  //     0b00000010000000000
  AmplitudeSdkInitialized: 1 << 11,
  //  0b00000100000000000
  SessionReplayActive: 1 << 12 //      0b00001000000000000
};
// this flagging system is largely so we can make assertions into the Amplitude object's internal
// operations at a very granular level. Since everything operates asynchronously, it can be tricky
// to know when some things have/have not been attempted simply by spying on function calls that may
// or may not have happened.
var StatusFlags = exports.StatusFlags = /*#__PURE__*/function () {
  function StatusFlags() {
    _classCallCheck(this, StatusFlags);
    this.statusFlags = 0;
  }
  return _createClass(StatusFlags, [{
    key: "set",
    value: function set(flag) {
      this.statusFlags |= flag;
    }
  }, {
    key: "clear",
    value: function clear(flag) {
      var clearMask = ~flag;
      this.statusFlags = this.statusFlags & clearMask;
    }
  }, {
    key: "get",
    value: function get(flag) {
      return (this.statusFlags & flag) > 0;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this.statusFlags;
    }
  }]);
}();
//# sourceMappingURL=flags.js.map